import { useEffect } from "react";
import { useMap } from "react-leaflet";

export function useCenterOn(target: { lat: number; lng: number } | null, zoom = 19) {
  const map = useMap();
  useEffect(() => {
    if (!target) return;
    map.setView([target.lat, target.lng], zoom, { animate: true });
  }, [map, target, zoom]);
}